import { useMutation } from 'react-query'
// import jwt_decode from 'jwt-decode'
import swal from 'sweetalert'

import { privateAPI } from '../config/constants'
import { decrypt } from '../functions/globalFunctions'
import * as reportTypes from '../redux/types/reportTypes'

export const getAllDayWiseAnalysis = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:10 ~ getAllDayWiseAnalysis ~ payload:', payload)
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/day-wise-analysis`, { data: data })
    console.log(
      '🚀 ~ file: reportHooks.js:16 ~ getAllDayWiseAnalysis ~ decrypt(res.data):',
      decrypt(res.data),
    )
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllConsolidatedDayWiseAnalysis = async (payload) => {
  console.log(
    '🚀 ~ file: reportHooks.js:24 ~ getAllConsolidatedDayWiseAnalysis ~ payload:',
    payload,
  )
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/consolidated-day-wise-analysis`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:30 ~ getAllConsolidatedDayWiseAnalysis ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllTimeWiseAnalysis = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:38 ~ getAllTimeWiseAnalysis ~ payload:', payload)
  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/time-wise-analysis`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:43 ~ getAllTimeWiseAnalysis ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllHourlyAnalysis = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:51 ~ getAllHourlyAnalysis ~ payload:', payload)
  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/hour-wise-analysis`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:56 ~ getAllHourlyAnalysis ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllShopWiseAnalysis = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:52 ~ getAllShopWiseAnalysis ~ payload:', payload)
  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/shop-wise-analysis`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:56 ~ getAllShopWiseAnalysis ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllMisreportedAnalysis = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:65 ~ getAllMisreportedAnalysis ~ payload:', payload.data)
  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/misreported-numbers`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:71 ~ getAllMisreportedAnalysis ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllMisreportedInvoices = async (payload) => {
  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/misreported-number-invoices`, { data: data })
    console.log('🚀 ~ getAllMisreportedInvoices ~ res.data:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
export const getAllHourlyMobiles = async (payload) => {
  console.log('🚀 ~ file: reportHooks.js:91 ~ getAllHourlyMobiles ~ payload:', payload)

  try {
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/get-hourly-mobiles`, { data: data })
    console.log('🚀 ~ file: reportHooks.js:96 ~ getAllHourlyMobiles ~ res:', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllCategoryWiseAnalysis = async (payload) => {
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/category-wise-analysis`, { data: data })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllNewReturningWiseAnalysis = async (payload) => {
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/newreturning-analysis`, { data: data })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllInclusionAnalysisChart = async (payload) => {
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/inclusion-analysis`, { data: data })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllLostCustomerByYear = async (payload) => {
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/get-year-wise-lost-customer`, { data: data })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

export const getAllInclusionTableData = async (payload) => {
  try {
    // let mode = getMode()
    let data = { ...payload }
    const res = await privateAPI.post(`/reports/get-inclusion-table-data`, { data: data })
    return decrypt(res.data)
  } catch (error) {
    console.log(error)
  }
}

// -------------------- REACT QUERY HOOK ---------------------- //
export const useGetAllDayWiseAnalysis = (dispatch) => {
  return useMutation(getAllDayWiseAnalysis, {
    onSuccess: (payloadData) => {
      console.log('🚀 ~ file: reportsHooks.js ~ useGetAllDayWiseAnalysis ~ data:', payloadData.data)

      dispatch({
        type: reportTypes.GET_DAYWISE_ANALYSIS,
        payload: payloadData,
      })
      dispatch({
        type: reportTypes.GET_DAYWISE_ANALYSIS_SEARCH,
        payload: payloadData,
      })
      console.log('GET ALL DAY WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllConsolidatedDayWiseAnalysis = (dispatch) => {
  return useMutation(getAllConsolidatedDayWiseAnalysis, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:62 ~ useGetAllConsolidatedDayWiseAnalysis ~ payloadData:',
        payloadData.data,
      )

      dispatch({
        type: reportTypes.GET_CONSOLIDATED_DAYWISE_ANALYSIS,
        payload: payloadData,
      })
      dispatch({
        type: reportTypes.GET_CONSOLIDATED_DAYWISE_ANALYSIS_SEARCH,
        payload: payloadData,
      })
      console.log('GET ALL CONSOLIDATED DAY WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllTimeWiseAnalysis = (dispatch) => {
  return useMutation(getAllTimeWiseAnalysis, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:97 ~ useGetAllTimeWiseAnalysis ~ payloadData:',
        payloadData.data,
      )

      dispatch({
        type: reportTypes.GET_TIMEWISE_ANALYSIS,
        payload: payloadData,
      })

      dispatch({
        type: reportTypes.GET_TIMEWISE_ANALYSIS_SEARCH,
        payload: payloadData,
      })

      console.log('GET ALL TIME WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllHourlyAnalysis = (dispatch) => {
  return useMutation(getAllHourlyAnalysis, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:155 ~ useGetAllHourlyAnalysis ~ payloadData:',
        payloadData.data,
      )
      console.log(dispatch)
      dispatch({
        type: reportTypes.GET_HOURLY_ANALYSIS,
        payload: payloadData,
      })

      console.log('GET ALL HOURLY DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllShopWiseAnalysis = (dispatch) => {
  return useMutation(getAllShopWiseAnalysis, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:133 ~ useGetAllShopWiseAnalysis ~ payloadData:',
        payloadData.data,
      )

      dispatch({
        type: reportTypes.GET_SHOPWISE_ANALYSIS,
        payload: payloadData,
      })

      // dispatch({
      //   type: reportTypes.GET_TIMEWISE_ANALYSIS_SEARCH,
      //   payload: payloadData,
      // })

      console.log('GET ALL SHOP WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetMisreportedAnalysis = (dispatch) => {
  return useMutation(getAllMisreportedAnalysis, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:168 ~ useGetMisreportedAnalysis ~ payloadData:',
        payloadData.data,
      )

      dispatch({
        type: reportTypes.GET_MISREPORTED_ANALYSIS,
        payload: payloadData,
      })

      console.log('GET ALL MISREPORTED WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetMisreportedInvoices = (dispatch) => {
  return useMutation(getAllMisreportedInvoices, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:168 ~ useGetMisreportedInvoices ~ payloadData:',
        payloadData.data,
      )

      dispatch({
        type: reportTypes.GET_MISREPORTED_INVOICES,
        payload: payloadData,
      })

      console.log('GET ALL MISREPORTED INVOICES WISE DATA', payloadData)
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllHourlyMobiles = (dispatch) => {
  return useMutation(getAllHourlyMobiles, {
    onSuccess: (payloadData) => {
      console.log(
        '🚀 ~ file: reportHooks.js:198 ~ useGetAllHourlyMobiles ~ payloadData:',
        payloadData,
      )

      dispatch({
        type: reportTypes.GET_HOURLY_MOBILES,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllCategoryAnalysis = (dispatch) => {
  return useMutation(getAllCategoryWiseAnalysis, {
    onSuccess: (payloadData) => {
      dispatch({
        type: reportTypes.GET_CATEGORYWISE_ANALYSIS,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllNewReturningAnalysis = (dispatch) => {
  return useMutation(getAllNewReturningWiseAnalysis, {
    onSuccess: (payloadData) => {
      dispatch({
        type: reportTypes.GET_NEWRETURNING_ANALYSIS,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllInclusionAnalysisChart = (dispatch) => {
  return useMutation(getAllInclusionAnalysisChart, {
    onSuccess: (payloadData) => {
      dispatch({
        type: reportTypes.GET_INCLUSION_ANALYSIS,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllLostCusByYear = (dispatch) => {
  return useMutation(getAllLostCustomerByYear, {
    onSuccess: (payloadData) => {
      dispatch({
        type: reportTypes.GET_INCLUSION_ANALYSIS_CUS_YEAR,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetAllInclusionTableData = (dispatch) => {
  return useMutation(getAllInclusionTableData, {
    onSuccess: (payloadData) => {
      dispatch({
        type: reportTypes.GET_INCLUSION_TABLE_DATA,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}
